import { css, CSSObject, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';
import { BadgeColor } from './InsuranceSelectBadge';

const getBadgeColorStyles = (theme: Theme, color: BadgeColor): CSSObject => {
    switch (color) {
        case BadgeColor.BASE:
            return {
                backgroundColor: theme.palette.gray[100],
                border: `1px solid ${theme.palette.gray[900]}`,
                color: theme.palette.gray[900],
            };
        case BadgeColor.WARN:
            return {
                backgroundColor: theme.palette.alert.light,
                border: `1px solid ${theme.palette.alert.main}`,
                color: theme.palette.alert.main,
            };
        case BadgeColor.GREEN:
            return {
                backgroundColor: theme.palette.success.light,
                border: `1px solid ${theme.palette.success.main}`,
                color: theme.palette.success.main,
            };
        default: {
            const exhaustiveCheck: never = color;
            throw new Error(exhaustiveCheck);
        }
    }
};

export const getInsuranceBadgeStyles =
    (color: BadgeColor) =>
    (theme: Theme): SerializedStyles =>
        css({
            padding: `${theme.spacing(0.5)}px ${theme.spacing(1)}px`,
            borderRadius: theme.borderRadius.L,
            ...getBadgeColorStyles(theme, color),
        });

export const getInsuranceBadgeTextStyles = (theme: Theme): SerializedStyles =>
    css({
        display: 'flex',
        alignItems: 'center',
        marginBottom: 0,
        fontWeight: theme.typography.fontWeight.bold,
    });

export const getInsuranceBadgeIconStyles = (theme: Theme): SerializedStyles =>
    css({
        marginRight: theme.spacing(0.5),
    });
